import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { GetEmployeeWagesList, GetEmployeeWagesLogsList, payrateGridBO } from './employee.model';
import { map } from 'rxjs/operators';
import { GetListBO } from '../employee-agreement/document/document.model';

@Injectable({
  providedIn: 'root'
})
export class EmployeepayrateService extends Subject<DataStateChangeEventArgs> {

  constructor(private http: HttpClient) {
    super();
  }

  public executepayrate(state: payrateGridBO): void {
    this.getListPayrate(state).subscribe(x => super.next(x));
  }

  getListPayrate(state?: payrateGridBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/EmployeePayrate/GetEmployeePayrateListFilter", state)
      .pipe(map(
        (response: any) => (<any>{
          result: response['result'],
          count: response['count']
        }))


      )
  }
  public executewages(state: GetEmployeeWagesList): void {
    this.getListEmployeewages(state).subscribe(x => super.next(x));
  }

  getListEmployeewages(state?: GetEmployeeWagesList): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/EmployeeyearlySummaries/GetEmpWagesLogsList", state)
      .pipe(map(
        (response: any) => (<any>{
          result: response['result'],
          count: response['count']
        }))


      )
  }

  public executewagesLogs(state: GetEmployeeWagesLogsList): void {
    this.getListEmployeewagesLogs(state).subscribe(x => super.next(x));
  }

  getListEmployeewagesLogs(state?: GetEmployeeWagesLogsList): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/EmployeeyearlySummaries/GetEmpWagesLogsList", state)
      .pipe(map(
        (response: any) => (<any>{
          result: response['result'],
          count: response['count']
        }))


      )
  }
}
